import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import "./index.less";
import "./index.css";
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';
import featureFlagConfig from './config/feature-flag-config.tsx';
import FeatureFlagProvider from './components/shared/feature-flag-react-lite/feature-flag-provider.tsx';
import { oidcConfig } from './config/oidc-config';
import { ThemeProvider } from './components/shared/theme-context.tsx';

function ConfigProviderWrapper() {
  return (
    <ThemeProvider>
      <App />
    </ThemeProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <FeatureFlagProvider config={featureFlagConfig}>
        <AuthProvider {...oidcConfig}>
            <ConfigProviderWrapper />
        </AuthProvider>
      </FeatureFlagProvider>
    </BrowserRouter>
  </React.StrictMode>
);
